// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__bGHdY","projectsDark":"styles_projectsDark__J0l0p","projectsLight":"styles_projectsLight__hDvr5"};